import { IParsedWhitelabel } from '@/Interfaces/Whitelabels/Whitelabel.interface';
import { Box } from '@mui/material';
import { GridRenderCellParams } from '@mui/x-data-grid-pro';
import { FC } from 'react';

interface LogoProps {
  value?: string;
  background?: string;
  logoWidth?: string;
}

const Logo: FC<LogoProps> = ({ value, background, logoWidth }) => {
  const queryParam = logoWidth ? `?width=${logoWidth}` : '';
  return (
    <Box
      sx={{
        background: background,
        height: '100%',
        width: '100%',
        display: 'flex',
        justifyContent: 'center',
      }}
    >
      <img className='object-contain h-full' src={`${value}${queryParam}`} alt='Logo' />
    </Box>
  );
};

export const LogoCell = ({ value }: GridRenderCellParams<{ id: string }, string | undefined>) => {
  if (!value) {
    return false;
  }
  return <Logo value={value} logoWidth='100' />;
};

export const LogoWhitelabelCell = ({ value, row }: GridRenderCellParams<IParsedWhitelabel, string>) => {
  if (!value) {
    return false;
  }
  return <Logo value={value} background={row.loginBg} logoWidth='100' />;
};
